import { AppBar, Button, FormControlLabel, IconButton, Radio, RadioGroup, Toolbar, Typography } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

function TopBar(props) {
    const {title, buttons, buttonStyle, buttonClasses, appBarClasses, radios, handleRadioChange, radio, onClose = () => {}, type} = props;
    const history = useHistory();

    const handleClose = () => {
        if(type === 'modal') {
            onClose();
        } else {
            history.goBack();
        }
    }

    return (
        <AppBar position='static' className={appBarClasses}>
            <Toolbar variant="dense">
                <Typography 
                    variant='h6' 
                    color="inherit" 
                    style={{
                        flexGrow: 1, 
                        display: 'flex',
                        flexDirection: 'row', 
                        alignItems: 'center'
                    }}
                >
                    <span>
                        {title}
                    </span>
                    {radios &&
                    <span style={{marginLeft: 20}}>
                        <RadioGroup 
                            value={radio} 
                            onChange={handleRadioChange}
                            style={{
                                display: 'flex',
                                flexDirection: 'row'
                            }}
                        >
                        {
                            Object.keys(radios).map((key, index) => (
                                <FormControlLabel 
                                    key={`app-bar-radio-${index}`} 
                                    value={key} 
                                    control={<Radio />} 
                                    label={radios[key].text} 
                                /> 
                            ))
                        }
                        </RadioGroup>
                    </span>
                }   
                </Typography>
                <div style={{marginLeft: 16, marginRight: 24}}>
                    {buttons &&
                        buttons.map((item, index) => (
                            item.props.htmlFor ?
                                <label htmlFor={item.props.htmlFor}>
                                    <Button
                                        key={`app-bar-button-${index}`}
                                        className={buttonClasses}
                                        style={buttonStyle}
                                        {...item.props}
                                        component="span"
                                        id="topbar_buttons_button"
                                    >
                                        {item.title}
                                    </Button>
                                </label> :
                                <Button
                                    key={`app-bar-button-${index}`}
                                    className={buttonClasses}
                                    style={buttonStyle}
                                    {...item.props}
                                >
                                    {item.title}
                                </Button>
                        ))}
                </div>
                <IconButton 
                    color="inherit"
                    onClick={handleClose}
                >
                    <Close />
                </IconButton>
            </Toolbar>
        </AppBar>
    )
}

TopBar.defaultProps = {
   onClose: () => {}
}

export default TopBar;